import React from 'react';
import styled from 'styled-components';

import { SVGIcon } from '@superops/super-icons';
import {
  dompurifier,
  getTranslatedText,
  useUserMSPCheckHook
} from '@nile/components/src/Utils/helpers';
import { Link } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import Tippy from '@tippyjs/react';

const EmailStateWrapper = styled.div`
  align-self: center;
  margin-left: 8px;
  .tooltip {
    align-items: center !important;
    display: flex !important;
    white-space: pre-line;
  }
`;

const EmailFailureStatus = ({ toUsers, ccUsers, bccUsers, size }) => {
  const userMailFailureMap = {};
  const intl = useIntl();
  const isMsp = useUserMSPCheckHook();

  const addToFailureList = (userArray) => {
    userArray.forEach((user) => {
      if (user.mailFailureReason?.reason) {
        userMailFailureMap[user.user.email] = {
          mailDeliveryStatus: user.mailDeliveryStatus,
          mailFailureReason: user.mailFailureReason.reason
        };
      }
    });
  };

  [toUsers, ccUsers, bccUsers].forEach((userType) => {
    if (userType) addToFailureList(userType);
  });

  let tooltipMessage = '';

  Object.keys(userMailFailureMap).forEach((userId) => {
    tooltipMessage += `${userId} - ${userMailFailureMap[userId].mailDeliveryStatus}  (${userMailFailureMap[userId].mailFailureReason})\n`;
  });

  return tooltipMessage ? (
    <Tippy
      content={
        <div className="fx actr g10 col p10">
          <p
            className="max-height-250 scroll line-break-anywhere"
            dangerouslySetInnerHTML={{
              __html: dompurifier(tooltipMessage)
            }}
          />
          {isMsp && (
            <span className="mlauto">
              <Link onClick={() => window.Intercom('show')} removeUnderline>
                {/* <FormattedMessage id="app.pricing.contactsupport" /> */}
                {getTranslatedText(intl, 'app.pricing.contactsupport')}
              </Link>
            </span>
          )}
        </div>
      }
      duration={250}
      delay={500}
      interactive
      placement="bottom-start"
      arrow={false}
      allowHTML
      theme="light"
      appendTo={document.body}
    >
      <EmailStateWrapper className="flex">
        <SVGIcon name="InlineError" color="#ff1515" size={size} />
      </EmailStateWrapper>
    </Tippy>
  ) : null;
};

export default EmailFailureStatus;
